export default "__VITE_ASSET__ZiQN9HQ1__"